<panel *ngIf="!loading || !products.empty">
  <p header>{{"Danh sách hàng hóa" | lang}}</p>
  <div right class="flex column">
    <text-filter [target]="products" [placeholder]="'Tìm mã'"></text-filter>
    <button class="bg-success text-white std-margin-left" (click)="edit(null)" *ngIf="isAdmin"><i class="fa fa-plus"></i></button>
    <button class="bg-warning text-white std-margin-left" (click)="import()" *ngIf="isAdmin"><i class="fa fa-file-excel"></i></button>
    <button class="bg-primary text-white std-margin-left" (click)="synchronize()"><i class="fa fa-sync"></i></button>
  </div>
  <table responsive class="data hover">
    <tr>
      <th priority="8" class="text-right text-top" style="width: 0px">STT</th>
      <th priority="1" class="text-left text-top"><sortable [target]="products" [extractor]="extractor('SKU')" [selected]="true">{{"SKU" | lang}}</sortable></th>
      <th priority="7" class="text-left text-top">{{"Màu" | lang}}</th>
      <th priority="4" class="text-right text-top"><sortable [target]="products" [extractor]="extractor('AverageQuantity')">{{"Dài / nặng" | lang}}</sortable></th>
      <th *ngIf="isAdmin" priority="5" class="text-right text-top"><sortable [target]="products" [extractor]="extractor('UnitPrice')">{{"Giá nhập" | lang}}</sortable></th>
      <th *ngIf="isAdmin" priority="6" class="text-right text-top"><sortable [target]="products" [extractor]="extractor('ProfitMargin')">{{"Lãi" | lang}}</sortable></th>
      <th *ngIf="isAdmin" priority="6" class="text-right text-top"><sortable [target]="products" [extractor]="extractor('LogisticsMargin')">{{"Phí" | lang}}</sortable></th>
      <th property="2" class="text-right text-top"><sortable [target]="products" [extractor]="extractor('QuotePrice')">{{"Giá bán" | lang}}</sortable></th>
      <th *ngIf="isAdmin" priority="3" class="text-right text-top"></th>
    </tr>
    <tr *ngFor="let i of products.pageMatches; index as ix">
      <td><small>{{ix + 1 + products.pageIndex * products.pageSize}}</small></td>
      <td>
        <good class="bold text-primary nowrap" [sku]="i.SKU"></good>
        <div class="small nowrap opacity-50"><i class="fa fa-sync text-success hlf-margin-right"></i> {{i.Stamp | date : 'dd-MM-yyyy'}}</div>
      </td>
      <td class="colors">
        <span *ngFor="let c of i.Colors" class="text-warning bold">{{c.Color}}</span>
      </td>
      <td>
        {{i.AverageQuantity | number : '1.1-1' : 'en-US'}}<unit>{{(i.Unit == 1 ? 'm' : 'kg') | lang}}/{{'cây' | lang}}</unit>
      </td>
      <td *ngIf="isAdmin">
        <b [ngClass]="{'text-danger': i.UnitPrice <= 0}">{{i.UnitPrice | number : '1.0-2' : 'en-US'}}</b><cny-per-unit [type]="i.Unit"></cny-per-unit>
      </td>
      <td *ngIf="isAdmin"><b [ngClass]="{'text-danger': i.ProfitMargin <= 0}">{{i.ProfitMargin * 100 | number : '1.0-2' : 'en-US'}}</b><unit>%</unit></td>
      <td *ngIf="isAdmin"><b [ngClass]="{'text-danger': i.LogisticsMargin <= 0}">{{i.LogisticsMargin | number : '1.0-2' : 'en-US'}}</b><cny-per-unit [type]="i.Unit"></cny-per-unit></td>
      <td><b class="text-success">{{quote(i) | number : '1.0-2' : 'en-US'}}</b><vnd-per-unit [type]="i.Unit"></vnd-per-unit></td>
      <td *ngIf="isAdmin" class="nowrap">
        <i class="fa fa-edit text-primary pointer" (click)="edit(i)"></i>
        <i class="fa fa-copy text-primary pointer hlf-margin-left" (click)="copy(i)"></i>
        <i class="fa fa-times text-danger pointer std-margin-left" [ngClass]="{'pointer': deletable(i), 'opacity-0': !deletable(i)}" (click)="delete(i)"></i>
      </td>
    </tr>
    <tr>
      <td class="hidden"></td>
      <td [colSpan]="11" class="text-center" style="z-index: unset"><pagination [target]="products"></pagination></td>
    </tr>
    <tr class="footer">
      <td [colSpan]="11" class="text-center"><unit class="uppercase">{{'Tý giá' | lang}}</unit> <b class="text-danger spacy hlf-margin-left">{{exchange | number : '1.0-0' : 'en-US'}}</b><vnd-per-cny></vnd-per-cny></td>
    </tr>
  </table>
</panel>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
